export var defaultProps = {
  emphasis: "high",
  align: "left",
  htmlTag: "p"
};